import Base from '../../js/_base';
import SavedSearchHandler from './_saved-search-handler';

export default class SearchResult extends Base {
    get selectors() {
        return {
            advancedSearchDropdown: '.search-result__advanced',
            facetsWrapper: '.search-result__sidebar',
            facetsBtn: '.search-result__filters-btn',
            searchResultContent: '.search-result__content',
            dropdown: '.dropdown',
        };
    }

    get classList() {
        return {
            COL_FULL: 'full',
            COL_SHRUNK: 'shrunk',
        };
    }

    get elements() {
        return {
            advancedSearchDropdown: null,
            facetsWrapper: null,
            searchResultContent: null,
        };
    }

    constructor(searchResult) {
        super();
        this.searchResult = searchResult;
        this._elements = this.elements;
        this.timeout = null;
        this.initialize();
        this.addEventListeners();
    }

    initialize() {
        super.initialize();
        for (let key in this._elements) {
            this._elements[key] = this.searchResult.querySelector(this._selectors[key]);
        }
        document.body.addEventListener('click', this.bodyClick.bind(this));
        document.addEventListener('keyup', this.onKeyUp.bind(this));
    }

    addEventListeners() {
        super.addEventListeners();
        this.savedSearch = new SavedSearchHandler(this.searchResult);

        $(this._elements.facetsWrapper).on('shown.bs.collapse hide.bs.collapse', this.onSidebarToggleClick.bind(this));
    }

    onSidebarToggleClick(e) {
        if (e.target !== this._elements.facetsWrapper) {
            return;
        }
        this._elements.searchResultContent.classList.toggle(this._classList.COL_FULL);
        this._elements.searchResultContent.classList.toggle(this._classList.COL_SHRUNK);
    }
    bodyClick(e) {
        if (!e.target.closest(this._selectors.dropdown)) {
            $(this._elements.advancedSearchDropdown).collapse('hide');
        }
    }
    onKeyUp(e) {
        if (e.key === 'Escape') {
            $(this._elements.advancedSearchDropdown).collapse('hide');
        }
    }
}
